/**
 * Toast — notificações efêmeras (info/error).
 * A11y: role="alert" para erros, role="status" para info.
 */
import { t } from '@/i18n/index.js';

let container = null;
let escapeHandler = null;

export function mountToast(el) {
  container = el;
  if (!container) return;
  if (container.dataset.mounted === 'toast') return;
  container.dataset.mounted = 'toast';
  container.setAttribute('aria-live', 'polite');
}

/**
 * @param {{ message: string, type?: 'info' | 'success' | 'error', duration?: number }} opts
 * @returns {void}
 */
export function showToast({ message, type = 'info', duration }) {
  if (!container) {
    // fallback se ainda não montou: console
    if (type === 'error') console.error('[toast]', message);
    else console.info('[toast]', message);
    return;
  }

  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.dataset.type = type;
  toast.setAttribute('role', type === 'error' ? 'alert' : 'status');

  const msgEl = document.createElement('span');
  msgEl.textContent = message;
  toast.appendChild(msgEl);

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'toast-close';
  closeBtn.setAttribute('aria-label', t('common.close'));
  closeBtn.textContent = '×';
  closeBtn.addEventListener('click', () => dismiss(toast));
  toast.appendChild(closeBtn);

  container.appendChild(toast);

  if (type !== 'error') {
    // info: auto-dismiss
    const ms = Number.isFinite(duration) ? duration : 5000;
    setTimeout(() => dismiss(toast), ms);
  }

  // Foco vai pro botão fechar; Esc fecha
  closeBtn.focus();
  if (!escapeHandler) {
    escapeHandler = (e) => {
      if (e.key === 'Escape') {
        const toasts = [...container.querySelectorAll('.toast')];
        if (toasts.length > 0) {
          dismiss(toasts[toasts.length - 1]);
        }
      }
    };
    document.addEventListener('keydown', escapeHandler);
  }
}

function dismiss(toast) {
  if (!toast || !toast.parentElement) return;
  toast.style.opacity = '0';
  toast.style.transform = 'translateY(8px)';
  setTimeout(() => toast.remove(), 200);
  // se foi o último, remove o handler de Esc
  if (container && container.querySelectorAll('.toast').length === 0 && escapeHandler) {
    document.removeEventListener('keydown', escapeHandler);
    escapeHandler = null;
  }
}
